import { render, staticRenderFns } from "./RoomSubTypeDialog.vue?vue&type=template&id=3734373e"
import script from "./RoomSubTypeDialog.vue?vue&type=script&lang=ts"
export * from "./RoomSubTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports